export default __webpack_public_path__ + "0d9e169325dcc21fe65323ef7da4a6a3.png";